<template>
<body class="focused-form">
    <router-view></router-view>
</body>
</template>

<script>
export default {
}
</script>